// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".next-slide-enter-active,.next-slide-leave-active,.back-slide-enter-active,.back-slide-leave-active{transition:opacity .3s ease}.next-slide-enter,.next-slide-leave-active,.back-slide-enter,.back-slide-leave-active{transition:all .3s;opacity:0}.next-slide-leave-active{transform:translateX(-70px)}.back-slide-leave-active{transform:translateX(70px)}a:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
